import {Component, HostBinding, Input} from '@angular/core';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.scss']
})
export class DropdownItemComponent {
  @Input() icon: IconProp;
  @Input() active: boolean;
  @HostBinding('class.divider') @Input() divider: boolean;
  @HostBinding('class.disabled') @Input() disabled: boolean;
}
